import { gql } from '@apollo/client';

export const userFragment = gql`
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    profileImage
    originalEmail
  }
`;

export const groupFragment = gql`
  fragment GroupFragment on Group {
    id
    name
    color
    type
  }
`;

export const standUpAnswerFragment = gql`
  fragment StandUpAnswerFragment on StandUpAnswer {
    id
    standUpQuestion {
      id
      questionText
      type
    }
    addedLater
    createdAt
    content {
      task
      isChecked
      isPrevious
    }
    groups {
      ...GroupFragment
    }
    user {
      ...UserFragment
    }
    assignedTo {
      ...UserFragment
    }
    checked
  }
  ${userFragment}
  ${groupFragment}
`;

export const standUpFragment = gql`
  fragment StandUpFragment on StandUpEntry {
    id
    mood
    status
    createdAt
    updatedAt
    standUp {
      id
      standUpQuestions {
        id
        questionText
        type
      }
    }
    yesterday {
      count
      standUpAnswers {
        ...StandUpAnswerFragment
      }
    }
    today {
      count
      standUpAnswers {
        ...StandUpAnswerFragment
      }
    }
    blocker {
      count
      standUpAnswers {
        ...StandUpAnswerFragment
      }
    }
    user {
      ...UserFragment
    }
  }
  ${standUpAnswerFragment}
  ${userFragment}
`;
